export default "__VITE_ASSET__DH$pvS1Q__"